<template>
	<div class="col-12 mb-3">
		<div class="card mt-3 w-100">
			<h5 class="card-header"><i class="fas fa-cloud-download-alt"></i> Connect Your Devices</h5>

			<div v-if="isLoading == 1" class="text-center">
				<i class="fas fa-spinner fa-spin fa-2x p-2"></i>
			</div>

			<div v-if="typeof profileid === 'undefined'" class="row p-2">
				<div class="col-12 text-danger">* Create the account first</div>
			</div>

			<div class="card-body">
				<b-list-group v-for="stream in streams" :key="stream.id">
					<b-list-group-item class="mb-2">
						<div class="row" v-if="stream.slug == 'muse'">
							<label :for="stream.slug" class="col-12">
								MUSE CSV Upload
								<button class="px-2 infoModalBtn" v-b-modal="stream.title">
									<i class="fas fa-solid fa-info gold"></i>
								</button>
							</label>
							<b-modal :id="stream.title" :title="stream.title" ok-title="Close" ok-only>
								<div v-html="sanitizeHTML(stream.setup_info)"></div>
								<b-form @submit.stop.prevent>
									<b-form-group id="email_form" description="">
										<b-form-input
										v-model="email"
										type="email"
										required
										placeholder="Enter email"
										></b-form-input>
										<div class="pl-1" v-if="errors.email != ''">
											<small :class="errors.email_class" v-text="errors.email"></small>
										</div>
									</b-form-group>
								</b-form>
								<b-button v-if="processing === 0" block href="#" variant="primary" @click="museEmailSend">
									<i class="fas fa-sign-in-alt"></i> Send
								</b-button>
								<div v-else class="text-center gold">
									<i class="fas fa-atom fa-spin fa-2x"></i>
								</div>
							</b-modal>
							
							<div class="col-9">
								<b-form-file
									v-model="muse.file"
									ref="file"
									name="file"
									accept=".csv, .CSV"
								></b-form-file>

								<div class="col-lg-12 text-primary" v-if="muse.processing == 1">
									Uploading <i class="fas fa-spinner fa-spin"></i>
								</div>

								<div class="col-lg-12 text-primary" v-if="muse.message !== ''">
									<span v-html="muse.message"></span>
								</div>
							</div>

							<div v-if="muse.file !== null" class="col-3">
								<b-button type="button" @click="museUpload()" variant="primary"
									>Upload</b-button
								>
							</div>
						</div>

						<div v-else class="row">
							<label
								:for="stream.slug"
								class="col-12 col-form-label"
							>
								{{stream.title}}
								<button class="px-2 infoModalBtn" v-b-modal="stream.title">
									<i class="fas fa-solid fa-info gold"></i>
								</button>
							</label>
							<b-modal :id="stream.title" :title="stream.title" ok-title="Close" ok-only>
								<div v-html="sanitizeHTML(stream.setup_info)"></div>
								<div v-if="stream.slug == 'fitbit'">
									<p> Click the button below to authorize FitBit API access.	 </p>
									<b-button @click="fitbitFetchData(stream)">
										Get Latest Data
									</b-button>
								</div>

							</b-modal>
							<div class="col-10">
								<input
									type="text"
									class="form-control mb-1"
									:id="stream.slug"
									:placeholder="stream.token_name"
									v-model="stream.api_user_id"
									@keyup="streamClassChange(stream, 2)"
								/>
							</div>
							<div class="col-2 text-right" v-if="stream.class != ''">
								<button
									type="button"
									class="btn btn-sm"
									:class="stream.class"
									@click="UpdateStreamSettings(stream)"
								>
									<span v-if="stream.class == 'btn-primary'">Save</span>
								</button>
							</div>
						</div>
					</b-list-group-item>
				</b-list-group>
			</div>
		</div>
	</div>
</template>

<script>
import axios from 'axios';
import DOMPurify from 'dompurify';
export default {
	props: {
		profileid: null,
	},
	data() {
		return {
			isLoading: 1,
			streams: {},
			muse: {
				file: null,
				processing: 0,
				message: '',
			},
			errors: {
				email: "",
				email_class: "text-danger",
			},
			email: null,
			processing: 0,
		};
	},
	mounted() {
		this.getDataStreams();
		/*this.renderChart(this.chartdata, this.options)*/
	},

	methods: {
		sanitizeHTML(html) {
      		return DOMPurify.sanitize(html);
    	},
		checkEmailInput() {
			let valid = 0;
      		this.errors.email = "";
			if (this.email === "" || this.email === null) {
				this.errors.email = "Enter an email";
			} else if (!this.validEmail(this.email)) {
				this.errors.email = "Enter a valid email";
			} else {
				valid = 1;
				this.errors.email_class = "text-success";
			}
			console.log(valid)
			return valid;
		},
		validEmail(email) {
			var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
			var val = re.test(email);
			return val;
		},
		getDataStreams() {
			let _this = this;
			let params = new URLSearchParams();
			params.append('token', this.profileid);
			axios({
				url: _this.$store.state.api_url + 'dataStreamsGet',
				params: params,
			})
				.then(function (response) {
					if (response.data.status == 1) {
						_this.streams = response.data.streams;
					} else {
						_this.streams = null;
					}
					_this.isLoading = 0;
				})
				.catch(function () {});
		},
		museEmailSend() {
			let _this = this;
			
			let params = new URLSearchParams();
			if (_this.checkEmailInput() == 0) return false;
			_this.processing = 1;
			params.append('token', _this.$store.state.session_id);
			params.append("email", _this.email);
			axios({
				url: _this.$store.state.api_url + 'museEmailSend',
				params: params,
			})
				.then(function (response) {
					
					if (response.data.status == 1) {
						_this.errors.email = 'Successfuly sent email!';
						_this.errors.email_class = "text-success";
					} else {
						_this.errors.email = 'Failed to send email.';
						_this.errors.email_class = "text-danger";
					}
					_this.processing = 0;
				})
				.catch(function () {});
		},
		museUpload() {
			let _this = this;

			_this.muse.processing = 1;
			_this.muse.message = '';

			let formData = new FormData();
			formData.append('token', _this.$store.state.session_id);
			formData.append('file', _this.muse.file);
			formData.append('user_token', _this.profileid);

			axios({
				method: 'post',
				url: _this.$store.state.api_url + 'museCsvUpload',
				headers: { 'Content-Type': 'multipart/form-data' },
				data: formData,
			})
				.then(function (response) {
					_this.muse.message = response.data.message;
					_this.muse.processing = 0;
					_this.muse.file = null;
				})
				.catch(function (error) {
					console.log(error);
				});
		},

		streamClassChange(item, status) {
			if (status == 3) {
				item.class = '';
				item.icon = '';
			} else if (item.value != item.api_user_id) {
				item.class = 'btn-primary';
				item.icon = 'far fa-hand-point-down';
			} else if (status == 1) {
				item.class = 'text-success';
				item.icon = 'fas fa-check';
			} else if (status == -1) {
				item.class = 'text-danger';
				item.icon = 'fas fa-times';
			} else {
				item.class = '';
				item.icon = '';
			}

			return item;
		},

		UpdateStreamSettings(stream) {
			let _this = this;

			stream.class = 'text-success';
			stream.icon = 'fas fa-spinner fa-spin';

			let params = new URLSearchParams();
			params.append('token', this.profileid);
			params.append('data_stream_settings_id', stream.user_data_id);
			params.append('data_stream_id', stream.id);
			params.append('value', stream.api_user_id);
			axios({
				url: _this.$store.state.api_url + 'dataStreamSet',
				params: params,
			})
				.then(function (response) {
					if (response.data.status == 1) {
						stream.user_data_id = response.data.data_stream_settings_id;
						stream = _this.streamClassChange(stream, 3);
					} else {
						stream = _this.streamClassChange(stream, -1);
					}
				})
				.catch(function () {});
		},
		fitbitFetchData(item) {
			var link = item.auth_link + this.$store.state.session_id;
			window.location.href = link;
			item.processing = 1;
			console.log('fitbitFetchData');
			let _this = this;
			let params = new URLSearchParams();
			params.append('token', this.$store.getters.userTokenGet);
			params.append('user_id', this.profile.id);

			axios({
				url: _this.$store.state.env.api_url + 'fitbitUserData_Fetch',
				params: params,
			})
				.then(function (response) {
					item.processing = 0;
					item.message = response.data.message;
					if (response.data.status === 1) {
						item.last_updated = response.data.last_updated;
					}
				})
				.catch(function (e) {
					console.log('Error userDevicesGet:' + e);
				});
		},
	},
};
</script>

<style scoped>
.infoModalBtn {
	background-color: inherit;
	border: none;
}

.infoModalBtn:focus {
	outline: none;
}
</style>